<template>
    <span @click.stop>
        <category-header :title="title"
                         :active="dropdownVisible"
                         :loading="loading"
                         @click="onToggleBar"
        />
        <ul v-if="dropdownVisible" class="group-category">
            <li>
                <slot></slot>
            </li>
        </ul>
    </span>
</template>

<script>
    import EventBus from "../services/EventBus"
    import CategoryHeader from "./CategoryHeader"

    export default {
        name: "GroupCategory",
        components: {CategoryHeader},
        props: {
            title: String,
            loading: Boolean,
        },
        data() {
            return {
                dropdownVisible: false,
            }
        },
        methods: {
            onToggleBar() {
                EventBus.$emit('category-dropdown-hide')

                if (this.dropdownVisible) {
                    EventBus.$emit('category-group-hide');
                } else {
                    EventBus.$emit('category-group-hide');
                    this.dropdownVisible = true;
                }
            },
        },
        mounted() {
            EventBus.$on('category-group-hide', () => {
                this.dropdownVisible = false;
            })
        }
    }
</script>

<style scoped lang="scss">
    ul.group-category {
        margin: 0;
        padding: 0;
        box-shadow: 0 4px 2px #ccc;
        max-height: calc(100vh - 480px);
        overflow: auto;

        & li {
            list-style-type: none;
        }

        @media (max-width: 1024px) {
            max-height: none !important;
        }
    }
</style>

<style lang="scss">
    .mobile-item ul.group-category {
        margin: 0;
        padding: 0;

        .item {
            max-height: none !important;
            overflow: auto;
        }
    }
</style>
